import React, { useCallback } from 'react';

// Material
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

// Material styles

// Helpers
import { Capitalize } from 'helpers/capitalize';

// Contants
import IMAGES from 'constants/images';

// Styles
import useStyles from './ReportComponents.styles';

interface CustomTabsInterface {
  setCurrNavGuide: (param: number) => void;
  currNavGuide: number;
  labels: string[];
  hasMiddleTab?: boolean;
  withoutCapitalized?: boolean;
}

const CustomTabs: React.FC<CustomTabsInterface> = ({
  setCurrNavGuide,
  currNavGuide,
  labels,
  hasMiddleTab = false,
  withoutCapitalized,
}) => {
  const classes = useStyles();

  const handleChangeNavigation = useCallback(
    (event: React.ChangeEvent<{}>, newValue: number) => {
      setCurrNavGuide(newValue);
    },
    [],
  );

  return (
    <Tabs
      className={classes.tabs}
      onChange={handleChangeNavigation}
      value={currNavGuide}>
      {labels.map((title: string, indix: number) => (
        <Tab
          style={{ textTransform: 'none' }}
          className={currNavGuide === indix ? classes.tabSelected : classes.tab}
          label={!withoutCapitalized ? Capitalize(title) : title}
        />
      ))}
      <Box
        className={
          currNavGuide === labels.length - 1
            ? classes.lastTabSelected
            : classes.lastTab
        }>
        <div />
      </Box>
    </Tabs>
  );
};

interface PrettiNameLineInterface {
  line: string;
  color?: string | boolean;
}
interface PrettiPrefixInterface {
  prefix?: string;
  color?: string | boolean;
}
const PrettiNameLine: React.FC<PrettiNameLineInterface> = ({ line, color }) => {
  const classes = useStyles();
  return (
    <Box display='flex' alignItems='center'>
      <Box
        className={classes.PrittiLine}
        style={{ background: color ? String(color) : '#9427EA' }}>
        {line.split('-')[0]}
      </Box>
      {line.split('-')[1]}
    </Box>
  );
};

const PrettiPrefix: React.FC<PrettiPrefixInterface> = ({ prefix, color }) => {
  const classes = useStyles();
  return (
    <Box display='flex' alignItems='center'>
      <Box
        className={classes.PrittiLine}
        style={{ background: color ? String(color) : '#9427EA' }}>
        {prefix || ''}
      </Box>
    </Box>
  );
};

interface EntryResumeInterface {
  currNavGuide: number;
  totalValue: number;
  totalValueGrouped: number;
  quantityEntry: number;
  quantityEntryGrouped: number;
}

const EntryResume: React.FC<EntryResumeInterface> = ({
  currNavGuide,
  totalValue,
  totalValueGrouped,
  quantityEntry,
  quantityEntryGrouped,
}) => {
  const classes = useStyles();

  return (
    <Box display='flex' alignItems='center'>
      <Box className={classes.resume}>
        <Box className={classes.contentImage}>
          <img src={IMAGES.REPORTS_ICONS.QUANTITY_ENTRY} alt='quantity' />
        </Box>
        {currNavGuide === 0 ? quantityEntry : quantityEntryGrouped}
      </Box>
      <Box className={classes.resume}>
        <Box className={classes.contentImage}>
          <img src={IMAGES.REPORTS_ICONS.TOTAL_ENTRY} alt='quantity' />
        </Box>
        {`R$ ${
          currNavGuide === 0
            ? totalValue.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            : totalValueGrouped.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
        }`}
      </Box>
    </Box>
  );
};

export { CustomTabs, PrettiNameLine, PrettiPrefix, EntryResume };
